<template>
    <div>
        <div
            v-for="field in allFields"
            :key="$uniqueId(field)"
            class="m-b-sm field"
        >
            <label class="label has-text-grey">{{field.label}}</label>
            <input
                v-model="address[field.key]"
                class="input"
                :class="{ 'is-danger' : errors.has($uniqueId(field)) }"
                :placeholder="field.label"
                v-validate="{ required : field.required }"
                :name="$uniqueId(field)"
            />
        </div>
    </div>
</template>

<script>

export default {
    name : 'Address',

    inject : ['$validator'],

    props : {
        value : {
            type : Object,
            required : true,
        },
        loading : {
            type : Boolean,
            required : false,
        },
    },

    data () {
        return {
        };
    },

    computed : {
        address : {
            get () {
                return this.value;
            },
            set (value) {
                this.$emit('input', value);
            },
        },
        allFields () {
            return [
                { key : 'name', label : 'Name', required : true },
                { key : 'companyName', label : 'Company Name', required : false },
                { key : 'email', label : 'Email', required : false },
                { key : 'phone', label : 'Phone', required : false },
                { key : 'addressLine1', label : 'Address 1', required : true },
                { key : 'addressLine2', label : 'Address 2', required : false },
                { key : 'city', label : 'City', required : true },
                { key : 'state', label : 'State', required : true },
                { key : 'postal', label : 'Postal', required : true },
                { key : 'country', label : 'Country', required : true },
            ];
        }
    },

};
</script>

<style lang="scss" scoped>
</style>
